import { Component, OnDestroy, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Ng2selectObject } from 'app/dto/ng2selectObject';
import { User } from 'app/models/user';
import { ServiceAreaService } from 'app/services/serviceArea.service';

import swal from "bootstrap-sweetalert";
import * as _ from 'lodash';

import { BsModalRef } from "ngx-bootstrap";
import { UserService } from 'app/services/user.service';


@Component({
  templateUrl: './user-create.component.html'
})
export class UserCreateComponent implements OnInit, OnDestroy {

  private _lock: Boolean;
  private _errorState: UserCreateComponent.ErrorState = UserCreateComponent.ErrorState.None;
  private ErrorStateEnum = UserCreateComponent.ErrorState;
  private _serviceAreaSelectItems: Ng2selectObject[];
  private _serviceAreaActiveItems: any[] = [];

  //Поля для конструирования нового пользователя
  private _name: string;
  private _email: string;
  private _isWritable: boolean;
  private _isAllowAllServiceArea: boolean;
  private _canCancelCalls: boolean;

  constructor(private serviceAreaService: ServiceAreaService,
    private userService: UserService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    public createUserModal: BsModalRef
    ) { }

  ngOnDestroy(): void {
    swal.close();
  }

  ngOnInit() {
    this.loadData();
  }


  private loadData(): void {
    this.serviceAreaService.getServiceAreas()
            .subscribe(serviceAreas => {
                this._serviceAreaSelectItems = _.map(serviceAreas, function(obj) { return new Ng2selectObject(obj.id.toString(), obj.name) });
            }, err => {
                this._errorState = UserCreateComponent.ErrorState.UnknownError;
                swal({
                    title: 'Ошибка',
                    text: 'Не удалось получить территории обслуживания. Попробуйте снова',
                    type: 'error',
                    confirmButtonText: 'Попробовать еще раз'
                }, () => {
                    this.loadData();
                });
            });
  }

  private close() {
    this.createUserModal.hide();
  }

  private removeServiceAreaItem(serviceArea: Ng2selectObject): void {
    _.remove(this._serviceAreaActiveItems, function (item) { return item.id == serviceArea.id; });
  }

  private onSubmit(createUserForm: NgForm) {
    if (createUserForm.valid || !this._lock) {
        this._lock = true;
        let user: User = new User();
        user.email = this._email;
        user.name = this._name;
        user.role = User.Role.Manager;
        user.permissions = this._isWritable ? User.Permissions.Read | User.Permissions.Write : User.Permissions.Read;
        user.isAllowedAllServiceArea = this._isAllowAllServiceArea;
        user.canCancelCalls = this._canCancelCalls;
        user.serviceAreaIds = this._isAllowAllServiceArea ? [] : _.map(this._serviceAreaActiveItems, "id");
        this.userService.createUser(user).subscribe(user => {
            swal({
              title: 'Ок',
              text: 'Пользователь успешно создан',
              type: 'success'
            }, () => this.close());
        }, err => {
            swal('Ошибка сохранения', 'При сохранении пользователя произошла ошибка. Возможно пользователь с таким именем или e-mail существует', 'error');
            this._lock = false;
        });
    }
  }

}


export namespace UserCreateComponent {

  export enum ErrorState {
      /**
      * Нет ошибок
      */
      None,
      /**
       * Сервер не может предоставить данные по локации или территории обслуживания
       */
      NoData,
      /**
       * Другая ошибка
       */
      UnknownError
  }

}



// WEBPACK FOOTER //
// /app/SPA/src/app/client/admin/user/create/user-create.component.ts